// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"643f669a","238":"4b1b27e6","263":"af2df96d","321":"2af8253c","443":"a4130ee2","453":"a5eccc01","918":"5dde8e47"}[chunkId] + ".chunk.js";
};